import { AnyAction } from 'redux'
import { createSelector } from 'reselect'
import { SIMILAR_PRODUCTS_ERROR, SIMILAR_PRODUCTS_DONE, SIMILAR_PRODUCTS_START, SIMILAR_PRODUCTS_RESET } from './constants'

interface SimilarProductsState {
  tileEntities: {
    byId: Util.StringDictionary<State.ProductTileEntity>
    allIds: string[]
  }
  loading: boolean
  error: Error | null
}

const initialState: SimilarProductsState = {
  tileEntities: {
    byId: {},
    allIds: [],
  },
  loading: false,
  error: null,
}

export function reducer(state: SimilarProductsState = initialState, action: AnyAction): SimilarProductsState {
  switch (action.type) {
    case SIMILAR_PRODUCTS_START:
      return {
        ...state,
        loading: action.payload,
        error: null,
      }
    case SIMILAR_PRODUCTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case SIMILAR_PRODUCTS_DONE: {
      const { tileEntities } = action.payload

      return {
        ...state,
        tileEntities: { ...tileEntities },
        loading: false,
        error: null,
      }
    }
    case SIMILAR_PRODUCTS_RESET:
      return initialState

    default:
      return state
  }
}

export const similarProductsIdsSelector = (state: State.GlobalState): string[] => state.similarProducts?.tileEntities?.allIds

export const similarProductsByIdSelector = createSelector(
  (state: State.GlobalState) => state.similarProducts?.tileEntities?.byId,
  (byId) =>
    (id: string): State.ProductTileEntity =>
      byId[id],
)

export const similarProductsLoadingSelector = (state: State.GlobalState): boolean => state.similarProducts?.loading
export const similarProductsErrorSelector = (state: State.GlobalState): Error | null => state.similarProducts?.error
